import {useRef} from "react";
import {CloseOutlined} from "@ant-design/icons";

function Uploader({title, changeValueHandler, value}) {
    const fileInputRef = useRef(null);
    return <>
        <div className={`w-[90%] md:w-[30%] mb-7 mx-auto  cursor-pointer`}>
            <p className={`pr-10 text-orange`}>{title}</p>
            <div  onClick={() => fileInputRef.current.click()}
                 className={`bg-gray2 rounded mt-2 text-white text-5xl text-center py-5`}>
                +
            </div>
            {value != null && <div className={`flex justify-between py-1 text-sm px-3 items-center mt-1 bg-blue-500`}>
                <p>{value}</p>
                <CloseOutlined onClick={(e) => changeValueHandler(null)}/>
            </div>}
        </div>
        <input ref={fileInputRef} onChange={(e) => changeValueHandler(e.target.files[0])} type="file" hidden/>
    </>
}

export default Uploader